export default function DemoNextSteps() {
  return (
    <div className="mb-5 rounded-xl border border-hairline bg-surface-2 p-4">
      <p className="text-sm font-semibold text-ink">Talebinizden sonra ne olacak?</p>
      <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm leading-relaxed text-ink-muted">
        <li>Hafta içi 09:00–18:00 arasında sizi arayıp tanıtım için uygun zamanı birlikte belirleriz.</li>
        <li>Demo ortamında masa, sipariş ve adisyon akışını gösterir, sorularınızı yanıtlarız.</li>
        <li>İhtiyacınıza uygun paket ve varsa entegrasyonların toplam ücretini netleştiririz.</li>
      </ol>
      <p className="mt-3 text-xs leading-relaxed text-ink-muted">
        Tanıtım ücretsizdir; talebiniz ödeme veya abonelik başlatmaz.
      </p>
    </div>
  );
}
